module.exports = __webpack_public_path__ + "static/media/1.a3c65b2.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/mp3/1.mp3
// module id = dgSP
// module chunks = 1